module.exports = __webpack_public_path__ + "static/media/logo3.1c230af7.svg";